import { apiGet } from '../../api'

export const get_curriculum_interactions = query => {
  const { program_id, day_type } = query
  return apiGet({
    endpoint: `programs/get_program_interactions?program_id=${program_id}&day_type=${day_type}`
  })
}
